import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from 'vuex'
import Echarts from 'echarts'
import 'echarts-gl'
import Axios from 'axios'

import {Pagination,Popover,Progress,Dialog,Menu,Submenu,MenuItem,MenuItemGroup,Input,Radio,RadioGroup,Switch,Select,
        Option,OptionGroup,Button,Form,FormItem,Icon,Row,Col,Upload,Message,MessageBox,Loading,
        DatePicker,Table,TableColumn,Card,Container,Aside,Footer,Header,Main,Scrollbar} from 'element-ui'


import * as api from './api/index'

Vue.use(Axios);

Vue.use(Pagination);Vue.use(Popover);Vue.use(Dialog);Vue.use(Menu);Vue.use(Submenu);
Vue.use(MenuItem);Vue.use(MenuItemGroup);Vue.use(Input);Vue.use(Radio);Vue.use(RadioGroup);
Vue.use(Switch);Vue.use(Select);Vue.use(Option);Vue.use(OptionGroup);Vue.use(Button);
Vue.use(Form);Vue.use(FormItem);Vue.use(Icon);Vue.use(Row);Vue.use(Col);Vue.use(Upload);
Vue.use(Loading);Vue.use(DatePicker);Vue.use(Table);Vue.use(TableColumn);
Vue.use(Card);Vue.use(Container);Vue.use(Aside);Vue.use(Footer);Vue.use(Header);Vue.use(Main);
Vue.use(Progress);Vue.use(Scrollbar);

Vue.prototype.$echarts = Echarts;//将Echarts挂载到Vue原型上
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$api = api;
Vue.config.productionTip = false;

/*this.$router.afterEach(function () {
  ws.close()
})*/


var vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
